import Error404 from "../components/404";

const SurveyError = ({ status, labels }) => {
  return (
    <div className="error-page">
      {status !== 404 && <div className="error-page__logo" />}
      {{
        404: <Error404 labels={labels} />,
        NOT_AVAILABLE: (
          <div className="error-page__content">
            <h1>{labels?.WELFARE_SURVEY_NOT_AVAILABLE || "Sorry, this survey is not available"}</h1>
            <a href="/" target="_blank" rel="noreferrer" className="link--text">
              <span>{labels?.WELFARE_GO_TO_OEL || "Go to One EssilorLuxottica"}</span>
            </a>
          </div>
        ),
        500: (
          <div className="error-page__content">
            <h1>{labels.WELFARE_SORRY_ERROR_OCCURRED || "Sorry, an error occurred"}</h1>
          </div>
        ),
        403: (
          <div className="error-page__content">
            <h1>
              {labels?.WELFARE_UNAUTHORIZED_MESSAGE ||
                "Sorry, but you don't have the permissions to see this page."}
            </h1>
            <a href="/" target="_blank" rel="noreferrer" className="link--text">
              <span>{labels?.WELFARE_GO_TO_OEL || "Go to One EssilorLuxottica"}</span>
            </a>
          </div>
        ),
      }[status] || (
        <div className="error-page__content">
          <h1>{labels.WELFARE_SORRY_ERROR_OCCURRED || "Sorry, an error occurred"}</h1>
        </div>
      )}
    </div>
  );
};

export default SurveyError;
